import { Component, OnInit } from '@angular/core';
import { BaseUpdateComponent, BaseDataService, NotificationService } from 'yt-ng-framework';
import { Sprema } from './sprema';
import { ActivatedRoute } from '@angular/router';
// import { NotificationsService } from 'angular2-notifications';
import { TranslateService } from '@ngx-translate/core';
import { Validators } from '@angular/forms';
// import { ToastrService } from 'ngx-toastr';



@Component({
  selector: 'yt-sprema-update',
  templateUrl: './sprema-update.component.html'
})
export class SpremaUpdateComponent 
extends BaseUpdateComponent<Sprema> 
implements OnInit {

  constructor(
    protected activatedRoute: ActivatedRoute,
    protected baseDataService: BaseDataService,
    // protected notificationsService: NotificationsService,
    protected toastrService: NotificationService,
    protected translateService: TranslateService
  ) {
    super(activatedRoute, baseDataService, toastrService, translateService);
  }

  ngOnInit() {
    super.ngOnInit();
    this.addValidatorToFc("Sifra", Validators.required, 'required', 'SPREMA.SIFRA.VALIDATION.REQUIRED');
    this.addValidatorToFc("Naziv", Validators.required, 'required', 'SPREMA.NAZIV.VALIDATION.REQUIRED');
    this.addValidatorToFc("Naziv", Validators.maxLength(250), 'maxlength', 'SPREMA.NAZIV.VALIDATION.MAXLENGTH');
    this.addValidatorToFc("Nivo", Validators.required, 'required', 'SPREMA.NIVO.VALIDATION.REQUIRED');
    this.addValidatorToFc("Nivo", Validators.maxLength(3), 'maxlength', 'SPREMA.NIVO.VALIDATION.MAXLENGTH');
    this.addValidatorToFc("Opis", Validators.maxLength(250), 'maxlength', 'SPREMA.OPIS.VALIDATION.MAXLENGTH');
    this.addValidatorToFc("Ekvivalencija", Validators.maxLength(250), 'maxlength', 'SPREMA.EKVIVALENCIJA.VALIDATION.MAXLENGTH');
  }

}
